import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {JobDTO} from "../../model/job-dto.model";
import {FirebaseEventEnum} from "../../enum/firebase-event.enum";
import {CommonService} from "../../service/common.service";
import {FirebaseService} from "../../service/firebase.service";
import {JobsService} from "../../service/jobs.service";
import {DrawerModalComponent} from "../drawer-modal/drawer-modal.component";
import {APP_CONFIG_PARAMS} from "../../const/app-config";
import {TextValueVO} from "../text-value/text-value.component";
import {IonModal, ModalOptions, NavController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import * as _ from 'lodash';
import * as moment from "moment";

@Component({
  selector: 'app-job-announcement-item',
  templateUrl: './job-announcement-item.component.html',
  styleUrls: ['./job-announcement-item.component.scss'],
})
export class JobAnnouncementItemComponent implements OnInit, AfterViewInit {

  @ViewChild("drawerModal") drawerModal: IonModal;

  @Input() job: JobDTO;
  @Input() fullWidth: boolean;
  @Input() showSkeleton: boolean;
  @Input() vediTutte: boolean;

  isOpenModal: boolean;
  isLoadingDetail: boolean;
  description: TextValueVO;

  constructor(private commonService: CommonService,
              private jobService: JobsService,
              private navController: NavController,
              private firebaseService: FirebaseService) {
  }

  ngAfterViewInit(): void {

    this.drawerModal?.dismiss().then(() => {
      this.isOpenModal = false;
    });

  }

  ngOnInit() {
  }

  onOpenDetail() {

    if(this.vediTutte){
      this.navController.navigateForward(['/jobs']);
      return;
    }

    this.drawerModal.present();
    this.isOpenModal = true;

    this.isLoadingDetail = true;

    this.jobService.getDetail(this.job.providerId).subscribe((detail) => {
      this.job = detail;
      setTimeout(() => {
        this.isLoadingDetail = false;
      }, APP_CONFIG_PARAMS.SKELETON_TIMEOUT);

    });

  }

  onClose(){
    this.drawerModal.dismiss();
  }

  openLink(url: string) {
    this.commonService.onOpenLinkBrowser(url).then();
    this.firebaseService.logEvent(FirebaseEventEnum.CLICK_JOB, {
      job_title: this.job.name + "-",
      job_id: this.job.providerId
    });
  }

  async onShare() {
    await this.commonService.share({
      title: this.job.name,
      url: this.job.externalUrl,
      dialogTitle: 'Condivisi annuncio',
      text: this.job.description
    })
  }

}
